import React from 'react'

function AcademicPerformance() {
  return (
    <div>
      AcademicPerformance
    </div>
  )
}

export default AcademicPerformance
